import { Box, Typography } from '@branch-messenger/willow-ui'
import { BranchLogo } from '@branch-messenger/willow-ui/icons'

import { StyledRootLayoutFooter } from '../styles'

export const RootLayoutFooter = () => {
  return (
    <StyledRootLayoutFooter>
      <Box>
        <Typography $size="xs" color="muted">
          All rights reserved.
        </Typography>
        <Typography $size="xs" color="muted">
          Copyright © {new Date().getFullYear()} Branch.
        </Typography>
      </Box>
      <Box>
        <Typography $size="xs" color="muted">
          Powered by
        </Typography>
        <Box>
          <BranchLogo />
        </Box>
      </Box>
    </StyledRootLayoutFooter>
  )
}
